module.exports = __webpack_public_path__ + "static/media/clevered_green.504dc087.png";